<template>
  <div class="consume-edit">
    <style-bar :css-keys="['background', 'color']" class="mb-2" mode="text" :styles.sync="localStyles"></style-bar>
    <div class="py-2 px-4 form-ctn">
      <div class="font-weight-light" v-html="$t('consumeedit_note')"></div>
      <v-radio-group v-model="form.mode" @input="updateMode()">
        <v-radio :label="$t('automatic')" value="auto"></v-radio>
        <span class="font-weight-light pl-8 pb-2">{{$t('consumeedit_automatic_description')}}</span>
        <v-radio :label="$t('manual')" value="manual"></v-radio>
        <span class="font-weight-light pl-8 pb-2">{{$t('consumeedit_manual_description')}}</span>
      </v-radio-group>
      <v-text-field v-show="form.mode == 'manual' " class="pl-8 pt-0" v-model="form.consumeBtn" @input="updateButton()" :placeholder="$t('consumeedit_consume_now_placeholder')" :label="$t('consumeedit_consume_button_label')"></v-text-field>

      <rich-text-input :content.sync="form.content" mode="textarea" :json.sync="editorContentJson" :label="$t('consumeedit_description_before')"></rich-text-input>
      <rich-text-input :content.sync="form.consumedContent" mode="textarea" :json.sync="editorConsumedContentJson" :label="$t('consumeedit_description_after')"></rich-text-input>
    </div>
  </div>
</template>

<script>

import RichTextInput from '@/components/utils/RichTextInput'
import StyleBar from '@/components/utils/StyleBar'

export default {
  name: 'ConsumeEdit',
  props: ['content', 'consumed', 'button', 'mode', 'styles'],
  components: {
    'rich-text-input': RichTextInput,
    StyleBar
  },
  computed: {
    formMode () {
      return this.form.mode
    },
    formContent () {
      return this.form.content
    },
    formConsumed () {
      return this.form.consumed
    }
  },
  watch: {
    formContent () {
      this.updateContent()
    },
    formConsumed () {
      this.updateConsumedContent()
    },
    formMode () {
      this.updateMode()
    }
  },
  data () {
    return {
      formConsumedContent: '',
      form: {
        consumeBtn: 'Consume Now',
        content: '',
        consumedContent: '',
        mode: 'auto'
      },
      editorContentJson: {},
      editorConsumedContentJson: {},
      localStyles: {}
    }
  },
  created () {
    this.form.content = this.content
    if (typeof this.form.content !== 'string') {
      this.form.content = ''
    }

    this.form.consumedContent = this.consumed
    if (typeof this.form.consumedContent !== 'string') {
      this.form.consumedContent = ''
    }

    this.form.consumeBtn = this.button
    if (typeof this.form.consumeBtn !== 'string') {
      this.form.consumeBtn = ''
    }

    this.form.mode = this.mode
    if (!this.form.mode) {
      this.form.mode = 'auto'
    }

    if (this.styles) {
      this.localStyles = JSON.parse(JSON.stringify(this.styles))
    }
  },
  methods: {
    updateContent () {
      this.$emit('update:content', this.form.content)
    },

    updateConsumedContent () {
      this.$emit('update:consumed', this.form.consumedContent)
    },

    updateMode () {
      this.$emit('update:mode', this.form.mode)
    },

    updateButton () {
      this.$emit('update:button', this.form.consumeBtn)
    }
  }
}
</script>

<style lang="sass" scoped>

.consume-edit
  background: #f1f1f1

.form-ctn
  background: white

</style>
